import clsx from 'clsx';
import LandscapeIcon from './assets/landscape-icon.svg';
import { LogoMain } from '../../components/LogoMain';

type LandscapeOverlayProps = {
    className?: string;
};
export function LandscapeOverlay(props: LandscapeOverlayProps) {
    return (
        <div
            className={clsx(
                'absolute z-[1001] inset-0 bg-[#BD728C] bg-cover w-full h-full flex flex-col justify-center items-center',
                props.className,
            )}
        >
            <LogoMain className="absolute top-5 left-5" />
            <img src={LandscapeIcon} />
            <p className="text-xl font-light text-white">
                This experience is best viewed in portrait mode
            </p>
        </div>
    );
}
